import { useEffect } from 'react';
import { useAuthContext } from '@/features/auth/context/AuthContext';
import { tokenStorage } from '@/features/auth/utils/tokenStorage';

/**
 * Entry points of a new account (invitations, password setup) must not run on
 * top of a session left in this browser by another account: the stored access
 * token would load that account's data and role into the new flow. Drops any
 * stored app session when the page opens.
 */
export function useClearStaleSession(): void {
  const { clearLocalSession } = useAuthContext();

  useEffect(() => {
    if (tokenStorage.getAccessTokenOptional()) {
      clearLocalSession();
    }
  }, [clearLocalSession]);
}
